<template>
  <v-data-table
    :no-data-text="$t('appointment.table.noData')"
    :items-per-page="10"
    :headers="paymentHeaders"
    :items="payments"
    :footer-props="{
      'items-per-page-text': '',
      'items-per-page-options': [],
    }"
    mobile-breakpoint="20"
    single-expand
    disable-sort
    show-expand
  >
    <template v-slot:[`item.type`]="{ item }">
      <v-chip :color="paymentTypesColors(paymentTypes(item))" small>
        {{ $t(`transfer.details.types.${paymentTypes(item)}`) }}
      </v-chip>
    </template>
    <template v-slot:[`item.appointmentCode`]="{ item }">
      <TransferPaymentLink :item="item" />
    </template>
    <template v-slot:[`item.appointmentDate`]="{ item }">
      <span v-if="item.appointment && item.appointment.date" class="body-2">
        {{ formatDate(item.appointment.date) }}
      </span>
      <span class="body-2" v-else>---</span>
    </template>
    <template v-slot:[`item.created_at`]="{ item }">
      <span class="body-2" v-if="item.created_at">
        {{ formatDate(item.created_at) }}
      </span>
      <span class="body-2" v-else>---</span>
    </template>
    <template v-slot:[`item.total`]="{ item }">
      <span class="body-2" v-if="item.total">
        {{ formatMoney(item.total) }}
      </span>
      <span class="body-2" v-else>---</span>
    </template>
    <template v-slot:[`item.description`]="{ item }">
      <span class="body-2" v-if="item.description">
        {{ item.description }}
      </span>
      <span class="body-2" v-else>---</span>
    </template>
    <template v-slot:expanded-item="{ headers, item }">
      <td :colspan="headers.length" class="ma-0 pa-0">
        <v-card class="pa-5 grey lighten-4" elevation="0" tile flat>
          <h6 class="grey--text text-uppercase">
            {{ $t('transfer.details.payments.description') }}
          </h6>
          {{ item.description ? item.description : '---' }}
        </v-card>
      </td>
    </template>
  </v-data-table>
</template>

<script>
import { transferPaymentHeaders } from '@/views/listHeaders/transferHeaders'
import { catalogDate, catalogMonetary } from '@/util/catalog'
import { paymentTypesColors } from '@/util/colors'

import TransferPaymentLink from './TransferPaymentLink'

export default {
  name: 'PaymentsTable',

  props: {
    payments: {
      type: Array,
      required: true,
    },
  },

  components: {
    TransferPaymentLink,
  },

  methods: {
    paymentTypes(item) {
      if (item.appointment !== null) return 'appointment'
      if (item.mission !== null) return 'mission'
      if (item.appointment === null && item.mission === null) return 'detached'
    }
  },

  data() {
    return {
      paymentHeaders: transferPaymentHeaders,
      formatMoney: catalogMonetary,
      formatDate: catalogDate,
      paymentTypesColors,
    }
  },
}
</script>
